export const POINT_SETTING_SEASON_STATUS = {
  WAIT: 0, // 대기
  ING: 1, // 진행 중
  END: 2, // 종료
  ETC: 3,
} as const;

export type POINT_SETTING_SEASON_STATUS =
  (typeof POINT_SETTING_SEASON_STATUS)[keyof typeof POINT_SETTING_SEASON_STATUS];

export const POINT_LEDGER_STATUS = {
  MINE: 0, // 채굴
  REFERRAL: 1, // 레퍼럴
  BONUS: 2, // 보너스
  REFERRAL_MY: 3, // 추천인을 입력하면 자기 자신에게도 지급
} as const;
export type POINT_LEDGER_STATUS = (typeof POINT_LEDGER_STATUS)[keyof typeof POINT_LEDGER_STATUS];
